import { PreviewFrame } from "./PreviewFrame";

const NODES: { kind: "Trigger" | "Action" | "Condition"; label: string }[] = [
  { kind: "Trigger", label: "New lead created" },
  { kind: "Action", label: "Send SMS: Welcome" },
  { kind: "Action", label: "Wait 1 day" },
  { kind: "Condition", label: "Replied?" }
];

const KIND_COLOR: Record<(typeof NODES)[number]["kind"], string> = {
  Trigger: "#e6007e",
  Action: "#00a7de",
  Condition: "#f2994a"
};

/**
 * Teaser for the "one workflow on Core" cap: a four-node automation chain, the
 * shape the workflow builder itself draws. No dedicated Figma frame exists for
 * this paywall.
 */
export const WorkflowsPreview = () => (
  <PreviewFrame>
    <div className="flex h-full w-full items-center justify-center px-6">
      <div className="flex w-full items-center">
        {NODES.map((node, idx) => (
          <div key={node.label} className="flex flex-1 items-center">
            <div className="flex w-full flex-col gap-1 rounded-lg border border-alpha-100 bg-white px-3 py-3 shadow-sm">
              <div className="flex items-center gap-2">
                <span
                  className="h-2 w-2 shrink-0 rounded-full"
                  style={{ backgroundColor: KIND_COLOR[node.kind] }}
                  aria-hidden="true"
                />
                <span className="text-[11px] font-medium leading-4 text-content-400">
                  {node.kind}
                </span>
              </div>
              <p className="truncate text-[13px] font-bold leading-[18px] text-content-1000">
                {node.label}
              </p>
            </div>
            {idx < NODES.length - 1 ? (
              <span
                className="mx-1 h-px w-5 shrink-0 bg-content-200"
                aria-hidden="true"
              />
            ) : null}
          </div>
        ))}
      </div>
    </div>
  </PreviewFrame>
);
